import Router, { Route, RouteConfig } from "vue-router";
import { isMobileApp } from "@/shared/mobileHelper";
import DashboardVue from "./components/landing-pages/Dashboard.vue";
import AccountSummaryDashboard from "@/employee/components/landing-pages/accountSummaryDashboard/AccountSummaryDashboard.vue";
import SummaryDashboard from "@/employee/components/landing-pages/accountSummaryDashboard/SummaryDashboard.vue";
import ClaimAccountVue from "./components/landing-pages/ClaimAccount.vue";
import CashAccountBalance from "./components/landing-pages/CashAccountBalance.vue";
import EmployeeHome from "@/employee/components/landing-pages/Home.vue";
import Wizard from "@/employee/components/onboarding/Wizard.vue";
import * as RouteNames from "@/employee/route-names";
import PartnerPortalRedirect from "@/employee/components/landing-pages/PartnerPortalRedirect.vue";
import InvestmentAccount from "@/employee/components/landing-pages/InvestmentAccount.vue";
import HealthcareExpensesUnreviewed from "@/employee/components/healthcareExpense/HealthcareExpensesConfirmNew.vue";
import HealthcareExpensesUnreimbursed from "@/employee/components/healthcareExpense/HealthcareExpensesUnreimbursed.vue";
import HealthcareExpensesReimbursed from "@/employee/components/healthcareExpense/HealthcareExpensesReimbursed.vue";
import HealthcareExpenseClaims from "@/employee/components/healthcareExpense/HealthcareExpenseClaims.vue";
import ReimburseMeComponent from "@/employee/components/landing-pages/ReimburseMe.vue";
import ContributionPlanner from "@/employee/components/landing-pages/ContributionPlanner.vue";
import Resources from "@/employee/components/landing-pages/Resources.vue";
import TermsAndConditions from "@/employee/components/landing-pages/TermsAndConditions.vue";
import TermsAndConditionsMobile from "@/employee/components/landing-pages/TermsAndConditionsMobile.vue";
import Privacy from "@/shared/components/Privacy.vue";
import PrivacyMobile from "@/shared/components/PrivacyMobile.vue";
import FinancialConnectorRedirect from "@/employee/components/redirects/FinancialConnector.vue";
import ContributionsAll from "@/employee/components/contributions/RecentContributionsAll.vue";
import IndividualSignups from "@/employee/components/onboarding/IndividualSignups.vue";
import { LoginRoutes, LoginRouteNames } from "@/shared/loginRoutes";
import {
  AuthType,
  DrivewealthWizardStep,
  EmployeeNavItem,
  ManagedExpenseFilterType,
  TransferSchedule,
  TransactionFilter,
  UserOnboardingStepKey
} from "@/shared/types";
import UmbPortalRedirect from "@/employee/components/landing-pages/UmbPortalRedirect.vue";
import EmailVerify from "@/employee/components/landing-pages/EmailVerify.vue";
import OktaEmailVerify from "@/employee/components/landing-pages/OktaEmailVerify.vue";
import PersonalExpenseTracker from "@/employee/components/landing-pages/PersonalExpenseTracker.vue";
import PrintTermsFeeSchedule from "@/employee/components/onboarding/PrintTermsFeeSchedule.vue";
import Settings from "@/employee/components/settings/Settings.vue";
import LinkedAccountsSettings from "@/employee/components/settings/LinkedAccountsSettings.vue";
import HealthPlan from "@/employee/components/settings/HealthPlanSettings.vue";
import UserPreferenceSettings from "@/employee/components/settings/UserPreferenceSettings.vue";
import UserNotificationSettings from "@/employee/components/settings/hsaBank/UserNotificationSettings.vue";
import HsaDebitCards from "@/employee/components/settings/HsaDebitCards.vue";
import SsoValidateAccount from "@/employee/components/landing-pages/SsoValidateAccount.vue";
import LoadingSpinnerView from "@/employee/components/landing-pages/LoadingSpinnerView.vue";
import MyProfileEdit from "@/employee/components/settings/profile/MyProfileEdit.vue";
import MyProfileDisplay from "@/employee/components/settings/profile/MyProfileDisplay.vue";
import ContributionPlannerLearnMore from "@/employee/components/contributionPlanner/ContributionPlannerLearnMore.vue";
import Security from "@/employee/components/settings/Security.vue";
import * as SharedRoutes from "@/shared/route-names";
import EligibleExpenses from "@/employee/components/healthcareExpenseV2/EligibleExpenses.vue";
import FindExpenses from "@/employee/components/healthcareExpenseV2/FindExpenses.vue";
import ViewClaims from "@/employee/components/healthcareExpenseV2/ViewClaims.vue";
import SamlError from "@/employee/components/landing-pages/SamlError.vue";
import Statements from "@/employee/components/landing-pages/Statements.vue";
import AvailableInvestmentsPage from "@/employee/components/investments/drivewealth/AvailableInvestmentsPage.vue";
import DrivewealthActivityPage from "@/shared/components/investments/drivewealth/ActivityPage.vue";
import QuestionnairePage from "@/employee/components/investments/drivewealth/QuestionnairePage.vue";
import DrivewealthLearnMorePages from "@/employee/components/investments/drivewealth/LearnMorePages.vue";
import DrivewealthChoiceOptionFundsList from "@/employee/components/investments/drivewealth/DrivewealthChoiceOptionFundsList.vue";
import DrivewealthDocumentsPage from "@/employee/components/investments/drivewealth/DrivewealthDocumentsPage.vue";
import DrivewealthFees from "@/employee/components/investments/drivewealth/DrivewealthFees.vue";
import SweepPageV2 from "@/employee/components/investments/drivewealth/SweepPageV2.vue";
import RequestBuyPage from "@/employee/components/investments/drivewealth/RequestBuyPage.vue";
import RequestSellPage from "@/employee/components/investments/drivewealth/RequestSellPage.vue";
import InstrumentPerformanceView from "@/shared/components/investments/drivewealth/InstrumentPerformanceView.vue";
import ContributionsV2 from "@/employee/components/landing-pages/ContributionsV2.vue";
import DocumentSignatureView from "@/employee/components/landing-pages/DocumentSignatureView.vue";
import DocumentView from "@/employee/components/landing-pages/DocumentView.vue";
import AccountCreationWizardPage from "@/employee/components/investments/drivewealth/wizard/AccountCreationWizardPage.vue";
import PreenrollmentPage from "@/employee/components/investments/drivewealth/wizard/PreenrollmentPage.vue";
import InvestmentAccountClaimPage from "@/employee/components/investments/drivewealth/wizard/InvestmentAccountClaimPage.vue";
import UmbInvestmentAccountPage from "@/employee/components/investments/UmbInvestmentAccountPage.vue";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import DrivewealthInvestmentPage from "@/employee/components/investments/drivewealth/DrivewealthInvestmentPage.vue";
import DrivewealthAccountLiquidationPage from "@/shared/components/investments/drivewealth/DrivewealthAccountLiquidationPage.vue";
import InitiateImpersonation from "@/employee/components/landing-pages/InitiateImpersonation.vue";
import ImpersonationError from "@/employee/components/landing-pages/ImpersonationError.vue";
import HsabClaimAccount from "@/employee/components/landing-pages/hsabank/HsabClaimAccount.vue";
import HsabAccountSelection from "@/employee/components/landing-pages/hsabank/HsabAccountSelection.vue";
import HsabClaimAccountVerify from "@/employee/components/landing-pages/hsabank/HsabClaimAccountVerify.vue";
import HsabNotionalDashboardComponent from "@/employee/components/landing-pages/hsabank/HsabNotionalDashboard.vue";
import BiometricAuthSettings from "@/employee/components/settings/BiometricAuthSettings.vue";
import FlaggingDebug from "@/employee/components/settings/FlaggingDebug.vue";
import SsoLoginError from "@/employee/components/landing-pages/SsoLoginError.vue";
import WexRedirect from "@/employee/components/landing-pages/WexRedirect.vue";
import EbtoClaim from "@/employee/components/landing-pages/EbtoClaim.vue";
import EbtoGeneralInformation from "@/employee/components/ebto/GeneralInformation.vue";
import EbtoPricingOffer from "@/employee/components/ebto/PricingOffer.vue";
import EbtoRetained from "@/employee/components/ebto/Retained.vue";
import EbtoTransferProcess from "@/employee/components/ebto/TransferProcess.vue";
import EbtoESignature from "@/employee/components/ebto/ESignature.vue";
import EbtoTransferComplete from "@/employee/components/ebto/TransferComplete.vue";
import ProductScanner from "@/employee/components/product-scanner/ProductScanner.vue";
import EbtoVerificationCode from "@/employee/components/ebto/SecurityVerification.vue";
import HsabNotionalAccount from "@/employee/components/landing-pages/hsabank/HsabNotionalAccount.vue";
import OktaSso from "@/employee/components/landing-pages/hsabank/OktaSso.vue";
import MultipleAccountSelection from "@/employee/components/investments/drivewealth/MultipleAccountSelection.vue";
import { userFeedbackTriggerRoutes, useUserFeedbackStore } from "@/employee/store/userFeedback";
import HsabExpenseManagement from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseManagement.vue";
import ContributionsEdit from "@/shared/components/contributionsV3/ContributionsEdit.vue";
import ConfirmContributionPage from "@/shared/components/contributionsV3/ConfirmContributionPage.vue";
import DrivewealthCuratedRtq from "@/employee/components/investments/drivewealth/DrivewealthCuratedRtq.vue";
import CustomerSignature from "@/employee/components/investments/drivewealth/wizard/CustomerSignature.vue";
import ManagePayrollContributions from "@/shared/components/contributionsV3/ManagePayrollContributions.vue";
import ManageOtherHsaAmount from "@/shared/components/contributionsV3/ManageOtherHsaAmount.vue";
import DistributionSchedules from "@/shared/components/distribution/DistributionSchedules.vue";
import DebitCardManager from "@/employee/components/settings/card-management/DebitCardManager.vue";
import _ from "lodash";
import { useUserStore } from "@/shared/store/user";
import { useLoginRedirectStore } from "@/shared/store/loginRedirect";
import { useNotifierStore } from "@/shared/store/notifier";
import { useWizardStore } from "@/employee/store/wizard";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useBrowserStore } from "@/employee/store/browser";
import OktaSsoError from "./components/landing-pages/OktaSsoError.vue";
import DrivewealthDisclosures from "@/employee/components/investments/drivewealth/DrivewealthDisclosures.vue";
import DrivewealthW9 from "@/employee/components/investments/drivewealth/DrivewealthW9.vue";
import DevinirNonCompliantAccountView from "@/employee/components/landing-pages/DevinirNonCompliantAccountView.vue";
import { useFdicStore } from "@/shared/store/fdic";
import MessageCenter from "@/employee/components/landing-pages/MessageCenter.vue";
import CurrentHoldings from "@/shared/components/investments/drivewealth/CurrentHoldings.vue";
import DrivewealthAccountSummaryView from "@/shared/components/investments/drivewealth/DrivewealthAccountSummaryView.vue";
import VerifyEmail from "@/employee/components/onboarding/VerifyEmail.vue";
import LoginInfo from "./components/onboarding/LoginInfo.vue";
import Transfers from "@/employee/components/onboarding/balance-transfer/BalanceTransfer.vue";
import OnboardingLinkedAccounts from "@/employee/components/onboarding/upfront-contribution/OnboardingLinkedAccounts.vue";
import OnboardingContribution from "@/employee/components/onboarding/upfront-contribution/OnboardingContribution.vue";
import OnboardingScheduleContribution from "@/employee/components/onboarding/upfront-contribution/OnboardingScheduleContribution.vue";
import OnboardingConfirmContributionPage from "@/employee/components/onboarding/upfront-contribution/OnboardingConfirmContributionPage.vue";
import OnboardingContributionScheduledMessage from "@/employee/components/onboarding/upfront-contribution/OnboardingContributionScheduledMessage.vue";
import OnboardingLinkBankAccountLandingPage from "@/employee/components/onboarding/upfront-contribution/OnboardingLinkBankAccountLandingPage.vue";
import UnsupportedBrowser from "@/employee/components/landing-pages/UnsupportedBrowser.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import { canAccessDebitCardManagement } from "@/employee/Utilities/DebitCardManagementAccessUtility";
import { watch } from "@vue/composition-api";

const routeToName = (routeName: string) => ({ name: routeName });
const DrivewealthAccountSignatureDocumentKey = "hsabank_investment_esign";

const routesArray: RouteConfig [] = [
    {
        path: "/cash-account/statements",
        name: RouteNames.StatementsByYear,
        component: Statements,
        props: route => ({
            year: /^\d{4}$/.test(<string>route.query.year) ? parseInt(<string>route.query.year, 10) : new Date().getFullYear()
        })
    },
    {
        path: "/resources/documents",
        name: RouteNames.ResourcesDocuments,
        component: Resources,
        props: route => {
          const activeTab = route.params.symbol ? route.params.symbol.toLowerCase() : RouteNames.ResourcesDocuments;
          return {
            year: /^\d{4}$/.test(<string>route.query.year) ? parseInt(<string>route.query.year, 10) : new Date().getFullYear(),
            symbol: activeTab
          };
        },
        meta: {
          nav_item: EmployeeNavItem.Resources
        }
    },
    {
        path: "/resources/combined-documents",
        name: RouteNames.ResourcesDocuments,
        component: Resources,
        props: route => {
          const activeTab = route.params.symbol ? route.params.symbol.toLowerCase() : RouteNames.ResourcesDocuments;
          return {
            year: /^\d{4}$/.test(<string>route.query.year) ? parseInt(<string>route.query.year, 10) : new Date().getFullYear(),
            symbol: activeTab
          };
        },
        meta: {
          nav_item: EmployeeNavItem.Resources
        }
    },
  {
    path: "/fee-schedule/print",
    name: RouteNames.FeeSchedulePrint,
    component: PrintTermsFeeSchedule,
    meta: {
      hide_header: true,
      hide_footer: true,
      hide_left_nav: true
    }
  },
  ...LoginRoutes,
  {
    path: "/",
    name: RouteNames.Home,
    component: EmployeeHome,
    props: route => ({
      forcePageReload: route.params.forcePageReload,
      routeToContributions: { name: RouteNames.Contribution, query: { tab: route.query.tab }}
    }),
      beforeEnter: (to, from, next) => {
          const featureFlagStore = useFeatureFlagStore();
          if (featureFlagStore.flags.bend25644EnableSummaryDashboard) {
              return next({
                  name: RouteNames.Summary,
                  params: { ...to.params },
                  query: { ...to.query },
                  hash: to.hash,
                  replace: true,
              });
          }
          return next();
      },
    meta: {
      nav_item: EmployeeNavItem.Dashboard
    }
  },
  {
    path: "/accounts-summary",
    name: RouteNames.AccountsSummary,
      component: AccountSummaryDashboard,
      beforeEnter: (to, from, next) => {
          const featureFlagStore = useFeatureFlagStore();
          if (featureFlagStore.flags.bend25644EnableSummaryDashboard) {
              return next({
                  name: RouteNames.Summary,
                  hash: to.hash,
                  replace: true,
              });
          }
          return next();
      },
  },
  {
    path: "/accounts/closed",
    name: RouteNames.InactiveAccountsSummary,
    component: AccountSummaryDashboard,
    props: route => ({
      closedAccounts: true,
    })
  },
  {
    path: "/summary",
    name: RouteNames.Summary,
    component: SummaryDashboard,
    props: route => ({
      forcePageReload: route.params.forcePageReload,
      routeToContributions: { name: RouteNames.Contribution, query: { tab: route.query.tab } }
    }),
    meta: {
      nav_item: EmployeeNavItem.Summary
    }
  },
  {
    path: "/notional-account/:accountId",
    name: RouteNames.NotionalAccount,
    component: HsabNotionalAccount,
    props: route => {
      const pageNumber = route.query && route.query.page ? parseInt(<string>route.query.page, 10) : 1;
      const filter = parseInt(<string>route.query.transactionFilter) || 0;
      return {
        routeName: RouteNames.NotionalAccount,
        page: isNaN(pageNumber) ? 1 : pageNumber,
        transactionFilter: filter,
        routeToNotionalAccountBalance: (page, transactionFilter: TransactionFilter) => ({
          name: RouteNames.NotionalAccount,
          planType: route.params.accountId,
          query: {
            page,
            transactionFilter
          }
        })
      };
    }
  },
  {
    path: "/investment-account",
    name: RouteNames.InvestmentAccountInfo,
    component: InvestmentAccount,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/hsab",
    name: RouteNames.HsabInvestmentAccount,
    component: HsabInvestmentRedirectPage,
    meta: {
      hide_footer: true,
      hide_left_nav: true,
      hide_header: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/umb",
    name: RouteNames.UmbInvestmentAccount,
    component: UmbInvestmentAccountPage,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth",
    name: SharedRoutes.DrivewealthInvestmentAccount,
    component: DrivewealthInvestmentPage,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/liquidate/:accountId",
    name: SharedRoutes.DrivewealthAccountLiquidation,
    component: DrivewealthAccountLiquidationPage,
    props: route => ({
      accountId: parseInt(route.params.accountId)
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/documents/:accountId/:pageNumber?",
    name: SharedRoutes.DrivewealthInvestmentDocumentsV2,
    component: DrivewealthDocumentsPage,
    props: route => ({
      routeToDrivewealthDocumentsV2: (accountId, pageNumber) => ({
        name: SharedRoutes.DrivewealthInvestmentDocumentsV2,
        params: {
          accountId,
          pageNumber
        }
      }),
      accountId: parseInt(route.params.accountId),
      pageNumber: parseInt(route.params.pageNumber) || 1,
      hideNav: route.query.hn ? true : false
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/fees/:accountId?",
    name: SharedRoutes.DrivewealthInvestmentFeesV2,
    component: DrivewealthFees,
    props: route => ({
      accountId: parseInt(route.params.accountId)
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/account-selection",
    name: RouteNames.DrivewealthMultipleAccountSelection,
    component: MultipleAccountSelection,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/available-investments",
    name: SharedRoutes.DrivewealthAvailableInvestments,
    component: AvailableInvestmentsPage,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/available-investments/:accountId",
    name: SharedRoutes.DrivewealthAvailableInvestmentsV2,
    component: AvailableInvestmentsPage,
    props: route => ({
      accountId: parseInt(route.params.accountId)
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/signup",
    name: RouteNames.DrivewealthCreateAccount,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    component: AccountCreationWizardPage,
    props: {
      step: DrivewealthWizardStep.SelectAccountType
    }
  },
  {
    path: "/investment-account/drivewealth/signup/wizard/:step?",
    name: RouteNames.DrivewealthWizard,
    component: AccountCreationWizardPage,
    props: route => ({
      step: route.params.step
    }),
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
  },
  {
    path: "/investment-account/drivewealth/preenrollment",
    name: RouteNames.DrivewealthPreenrollment,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    component: PreenrollmentPage,
    props: {
      step: DrivewealthWizardStep.SelectAccountType,
      wizardNavigationRouteName: RouteNames.DrivewealthPreenrollmentWizard
    }
  },
  {
    path: "/investment-account/drivewealth/investment-account-claims/wizard/:accountId/:step?",
    name: RouteNames.DrivewealthInvestmentAccountClaims,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    component: InvestmentAccountClaimPage,
    props: route => ({
      accountId: parseInt(route.params.accountId),
      step: route.params.step,
      wizardNavigationRouteName: RouteNames.DrivewealthInvestmentAccountClaims,
    })
  },
  {
    path: "/investment-account/drivewealth/preenrollment/wizard/:step?",
    name: RouteNames.DrivewealthPreenrollmentWizard,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    component: PreenrollmentPage,
    props: route => ({
      step: route.params.step,
      wizardNavigationRouteName: RouteNames.DrivewealthPreenrollmentWizard
    }),
  },
  {
    path: "/investment-account/drivewealth/questionnaire",
    name: RouteNames.DrivewealthQuestionnaire,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    component: QuestionnairePage
  },
  {
    path: "/investment-account/drivewealth/noncompliant-account/:accountId",
    name: RouteNames.DevinirNonCompliantAccountsLandingPage,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true,
      hide_left_nav: true
    },
    component: DevinirNonCompliantAccountView,
    props: route => ({
      accountId:  parseInt(route.params.accountId),
    })
  },
  {
    path: "/investment-account/drivewealth/v2/questionnaire/:accountId?",
    name: RouteNames.DrivewealthQuestionnaireV2,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    component: QuestionnairePage,
    props: route => ({
      accountId:  parseInt(route.params.accountId),
    })
  },
  {
    path: "/investment-account/drivewealth/choice-option/funds-list",
    name: RouteNames.DrivewealthChoiceOptionFundsList,
    component: DrivewealthChoiceOptionFundsList,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/learn-more/:subpage",
    name: RouteNames.DrivewealthLearnMorePages,
    component: DrivewealthLearnMorePages,
    props: {
      isOnboarding: false,
    },
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/activity",
    name: SharedRoutes.DrivewealthInvestmentActivity,
    component: DrivewealthActivityPage,
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/activity/:accountId?",
    name: SharedRoutes.DrivewealthInvestmentActivityV2,
    component: DrivewealthActivityPage,
    props: route => ({
      accountId: parseInt(route.params.accountId),
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/activity/transfers",
    name: SharedRoutes.DrivewealthInvestmentActivityTransfers,
    component: DrivewealthActivityPage,
    props: {
      isTransfers: true
    },
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/activity/transfers/:accountId?",
    name: SharedRoutes.DrivewealthInvestmentActivityTransfersV2,
    component: DrivewealthActivityPage,
    props: route => ({
      accountId: parseInt(route.params.accountId),
      isTransfers: true
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/activity/history",
    name: SharedRoutes.DrivewealthInvestmentActivityHistory,
    component: DrivewealthActivityPage,
    props: {
      isHistory: true
    },
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/activity/history/:accountId?",
    name: SharedRoutes.DrivewealthInvestmentActivityHistoryV2,
    component: DrivewealthActivityPage,
    props: route => ({
      accountId: parseInt(route.params.accountId),
      isHistory: true
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/current-holdings/:accountId?/:pageNumber",
    name: SharedRoutes.DrivewealthCurrentHoldings,
    component: CurrentHoldings,
    props: route => ({
        accountId: parseInt(route.params.accountId),
        pageNumber: parseInt(route.params.pageNumber) || 1
    }),
    meta: {
        nav_item: EmployeeNavItem.Invest,
        hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/account-summary/:accountId?",
    name: SharedRoutes.DrivewealthAccountSummary,
    component: DrivewealthAccountSummaryView,
    props: route => ({
        accountId: parseInt(route.params.accountId),
        force: (route.query && Boolean(route.query.force)),
    }),
    meta: {
        nav_item: EmployeeNavItem.Invest,
        hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/buy-instrument/:accountId/:symbol?",
    name: RouteNames.DrivewealthBuyInstrumentV2,
    component: RequestBuyPage,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: route => ({
      symbol: route.params.symbol.toUpperCase(),
      accountId: parseInt(route.params.accountId),
    })
  },
  {
    path: "/investment-account/drivewealth/v2/instrument-performance/:accountId/:symbol?/:isMutualFund",
    name: SharedRoutes.InstrumentPerformance,
    component: InstrumentPerformanceView,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: route => ({
      symbol: route.params.symbol.toUpperCase(),
      isMutualFund: route.params.isMutualFund,
      accountId: parseInt(route.params.accountId)
    })
  },
  {
    path: "/investment-account/drivewealth/v2/sell-instrument/:accountId/:symbol?",
    name: RouteNames.DrivewealthSellInstrumentV2,
    component: RequestSellPage,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: route => ({
      symbol: route.params.symbol.toUpperCase(),
      accountId: parseInt(route.params.accountId),
      doubleConfirm: false
    })
  },
  {
    path: "/investment-account/drivewealth/sell-instrument-confirm/:symbol?",
    name: RouteNames.DrivewealthSellInstrumentConfirm,
    component: RequestSellPage,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: route => ({
      symbol: route.params.symbol.toUpperCase(),
      doubleConfirm: true
    })
  },
  {
    path: "/investment-account/drivewealth/v2/sell-instrument-confirm/:accountId/:symbol?",
    name: RouteNames.DrivewealthSellInstrumentConfirmV2,
    component: RequestSellPage,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: route => ({
      symbol: route.params.symbol.toUpperCase(),
      accountId: parseInt(route.params.accountId),
      doubleConfirm: true
    })
  },
  {
    path: "/investment-account/drivewealth/documents/:pageNumber?",
    name: SharedRoutes.DrivewealthInvestmentDocuments,
    component: DrivewealthDocumentsPage,
    props: route => ({
      routeToDrivewealthDocuments: pageNumber => ({
        name: SharedRoutes.DrivewealthInvestmentDocuments,
        params: {
          pageNumber
        }
      }),
      pageNumber: parseInt(route.params.pageNumber) || 1
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/auto-funding",
    name: RouteNames.DrivewealthSweep,
    component: SweepPageV2,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: {
      isPreenrollment: false
    },
  },
  {
    path: "/investment-account/drivewealth/v2/auto-funding/:accountId?",
    name: RouteNames.DrivewealthSweepV2,
    component: SweepPageV2,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: route => ({
      isPreenrollment: false,
      isWizard: false,
      accountId: parseInt(route.params.accountId),
    }),
  },
  {
    path: "/investment-account/drivewealth/signup/auto-funding",
    name: RouteNames.DrivewealthSignupSweep,
    component: SweepPageV2,
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    },
    props: {
      isPreenrollment: true
    },
  },
  {
    path: "/investment-account/drivewealth/v2/risk-tolerance/:accountId?",
    name: RouteNames.DrivewealthCuratedRtq,
    component: DrivewealthCuratedRtq,
    props: route => ({
      accountId: parseInt(route.params.accountId),
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/account-document-signature/:accountId?",
    name: SharedRoutes.DrivewealthHsabAccountSignature,
    component: CustomerSignature,
    props: route => ({
      accountId: parseInt(route.params.accountId),
      documentKey: DrivewealthAccountSignatureDocumentKey,
      isWizard: false,
      enableCheckbox: true,
      redirectRouteName: (route.query && route.query.redirectRoute)
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/investment-account/drivewealth/v2/:accountId?",
    name: SharedRoutes.DrivewealthInvestmentAccountV2,
    component: DrivewealthInvestmentPage,
    props: route => ({
      accountId: parseInt(route.params.accountId),
      force: (route.query && Boolean(route.query.force)),
    }),
    meta: {
      nav_item: EmployeeNavItem.Invest,
      hide_fdic: true
    }
  },
  {
    path: "/dashboard",
    name: RouteNames.Dashboard,
    component: DashboardVue,
    meta: {
      nav_item: EmployeeNavItem.Dashboard
    }
  },
  {
    path: "/expense-management/:filter?",
    name: RouteNames.HsabExpenseManagement,
    component: HsabExpenseManagement,
    props: route => {
      const filter = route.params.filter ? route.params.filter : ManagedExpenseFilterType.MyExpenses;
      const id = route.query && route.query.id ? parseInt(<string>route.query.id, 10) : 0;
      return {
        hsabExpenseId: isNaN(id) ? 0 : id,
        filter
      };
    },
    meta: {
      nav_item: EmployeeNavItem.ExpenseManagement
    }
  },
  {
    path: "/expense/distribution-schedules",
    name: RouteNames.DistributionSchedules,
    component: DistributionSchedules,
    props: route => {
      const schedulesPage = route.query && route.query.schedulesPage
        ? parseInt(<string>route.query.schedulesPage, 10)
        : 1;
      return {
        schedulesPage: isNaN(schedulesPage) ? 1 : schedulesPage,
      };
    },
  },
  {
    path: "/healthcare-expenses",
    name: RouteNames.HealthcareExpenses,
    component: HealthcareExpensesUnreviewed,
    props: {
        routeToSettings: routeToName(RouteNames.Settings)
      },
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/unreviewed",
    name: RouteNames.HealthcareExpensesUnreviewed,
    component: HealthcareExpensesUnreviewed,
    props: {
        routeToSettings: routeToName(RouteNames.Settings)
      },
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/unreimbursed",
    name: RouteNames.HealthcareExpensesUnreimbursed,
    component: HealthcareExpensesUnreimbursed,
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/reimbursed",
    name: RouteNames.HealthcareExpensesReimbursed,
    component: HealthcareExpensesReimbursed,
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/claims",
    name: RouteNames.HealthcareExpenseClaims,
    component: HealthcareExpenseClaims,
    props: {
      SettingsRoute: {name: RouteNames.HealthPlanSettings}
    },
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/eligible-expenses",
    name: RouteNames.EligibleExpenses,
    component: EligibleExpenses,
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/find-expenses",
    name: RouteNames.FindExpenses,
    component: FindExpenses,
    props: {
        routeToSettings: routeToName(RouteNames.Settings)
      },
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/healthcare-expenses/view-claims",
    name: RouteNames.ViewClaims,
    component: ViewClaims,
    props: {
      SettingsRoute: {name: RouteNames.HealthPlanSettings}
    },
    meta: {
      nav_item: EmployeeNavItem.HealthcareExpenses
    }
  },
  {
    path: "/settings",
    name: RouteNames.Settings,
    component: Settings,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/linked-accounts",
    name: RouteNames.LinkedAccountsSettings,
    component: LinkedAccountsSettings,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/my-profile-edit",
    name: RouteNames.MyProfileEdit,
    component: MyProfileEdit,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/my-profile",
    name: RouteNames.MyProfileDisplay,
    component: MyProfileDisplay,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/health-plan",
    name: RouteNames.HealthPlanSettings,
    component: HealthPlan,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/notification-preferences",
    name: RouteNames.UserNotificationPreferences,
    component: UserNotificationSettings,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/preferences",
    name: RouteNames.UserPreferences,
    component: UserPreferenceSettings,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/hsa-debit-cards",
    name: RouteNames.HsaDebitCards,
    component: HsaDebitCards,
    meta: {
      nav_item: EmployeeNavItem.Settings
    }
  },
  {
    path: "/settings/debit-card-management",
    name: RouteNames.DebitCardManagement,
    component: DebitCardManager,
    meta: {
      nav_item: EmployeeNavItem.Settings
    },
    beforeEnter: (to, from, next) => {
      if (!canAccessDebitCardManagement()) {
        return next({ name: RouteNames.Summary });
      }

      return next();
    }
  },
  {
    path: "/resources/:symbol?",
    name: RouteNames.Resources,
    component: Resources,
    props: route => {
      const activeTab = route.params.symbol ? route.params.symbol.toLowerCase() : RouteNames.ResourcesDownloadableFiles;
      return {
        year: /^\d{4}$/.test(<string>route.query.year) ? parseInt(<string>route.query.year, 10) : new Date().getFullYear(),
        symbol: activeTab
      };
    },
    meta: {
      nav_item: EmployeeNavItem.Resources
    }
  },
  {
      path: "/financial-connector-redirect",
      name: RouteNames.FinancialConnectorRedirect,
      component: FinancialConnectorRedirect
  },
  {
      path: "/reimburse-me",
      name: RouteNames.ReimburseMe,
      component: ReimburseMeComponent
  },
  {
      path: "/contributions",
      name: RouteNames.Contribution,
      component: ContributionsV2,
      props: route => {
        const schedulesPage = route.query && route.query.schedulesPage
            ? parseInt(<string>route.query.schedulesPage, 10)
            : 1;
        const tab = (route.query && route.query.tab) || "activity";
        const activityPage = route.query && route.query.activityPage
            ? parseInt(<string>route.query.activityPage, 10)
            : 1;
        return {
          schedulesPage: isNaN(schedulesPage) ? 1 : schedulesPage,
          tab,
          activityPage: isNaN(activityPage) ? 1 : activityPage,
          routeToModifySchedule: (id: number) => ({
            name: RouteNames.ContributionsEdit,
            params: {
              id
            }
          })
        };
      },
      meta: {
        notifies_forward: true,
        nav_item: EmployeeNavItem.Contributions
      }
  },
  {
    path: "/contributions-edit/:id?",
    name: RouteNames.ContributionsEdit,
    component: ContributionsEdit,
    props: route => ({
      id: parseInt(route.params.id),
      routeToConfirmation: (schedule: TransferSchedule, isUpdate: boolean) => ({
        name: RouteNames.ConfirmContribution,
        params: {
          value: schedule,
          updating: isUpdate
        }
      }),
      defaultRecurring: route.query && route.query.defaultRecurring ? Boolean(route.query.defaultRecurring) : false,
      defaultPriorYear: route.query && route.query.defaultPriorYear ? Boolean(route.query.defaultPriorYear) : false,
    }),
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Contributions
    }
  },
  {
    path: "/manage-payroll-contributions",
    name: RouteNames.ManagePayrollContributions,
    component: ManagePayrollContributions,
    meta: {
      nav_item: EmployeeNavItem.Contributions
    }
  },
  {
    path: "/contributions/track-external-hsa",
    name: RouteNames.ContributionsManageOtherHsaAmounts,
    component: ManageOtherHsaAmount,
    meta: {
      nav_item: EmployeeNavItem.Contributions,
      notifies_forward: true
    },
    props: {
      routeToContributions: { name: RouteNames.Contribution }
    }
  },
  {
    path: "/confirm-contribution",
    name: RouteNames.ConfirmContribution,
    component: ConfirmContributionPage,
    props: route => {
      const page = route.query && route.query.page ? parseInt(<string>route.query.page, 10) : 1;
      return {
        schedule: route.params.value ? route.params.value : null,
        updating: route.params.updating || false,
        page: isNaN(page) ? 1 : page,
        routeToModifySchedule: (schedule: TransferSchedule) => ({
          name: RouteNames.ContributionsEdit,
          params: {
            value: schedule
          }
        })
      };
    },
    meta: {
      notifies_forward: true,
      nav_item: EmployeeNavItem.Contributions
    }
  },
    {
        path: "/document-signature-view",
        name: RouteNames.DocumentSignatureView,
        component: DocumentSignatureView,
        props: route => ({
            documentKey: route.query.documentKey,
            print: route.query.print === "true",
            hideSignature: route.query.hs === "true",
        }),
        meta: {
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        }
    },
  {
    path: "/document-view",
    name: RouteNames.DocumentView,
    component: DocumentView,
    props: route => ({
      documentKey: route.query.documentKey,
      print: route.query.print === "true"
    }),
    meta: {
      hide_footer: true,
      hide_left_nav: true,
      hide_header: true
    }
  },
    {
      path: "/drivewealth-disclosures",
      name: RouteNames.DrivewealthDisclosures,
      component: DrivewealthDisclosures,
      meta: {
          hide_footer: true,
          hide_left_nav: true,
          hide_header: true
      }
  },
  {
    path: "/drivewealth-w9",
    name: RouteNames.DrivewealthW9,
    component: DrivewealthW9,
    meta: {
        hide_footer: true,
        hide_left_nav: true,
        hide_header: true
    }
},
    {
        path: "/flags",
        name: RouteNames.FlaggingDebug,
        component: FlaggingDebug,
        meta: {
            allowAnonymous: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/contribution-planner",
        name: RouteNames.ContributionPlanner,
        component: ContributionPlanner,
        meta: {
          nav_item: EmployeeNavItem.ContributionPlanner
        }
    },
    {
        path: "/contribution-planner/how-it-works",
        name: RouteNames.ContributionPlannerHowItWorks,
        component: ContributionPlannerLearnMore,
        meta: {
          nav_item: EmployeeNavItem.ContributionPlanner
        }
    },
    {
        path: "/settings/security",
        name: SharedRoutes.Security,
        component: Security,
        meta: {
          nav_item: EmployeeNavItem.Settings
        }
    },
    {
        path: "/settings/biometric-login",
        name: RouteNames.BiometricAuthSettings,
        component: BiometricAuthSettings,
        meta: {
          nav_item: EmployeeNavItem.Settings
        }
    },
    {
        path: "/expense-tracker",
        name: RouteNames.PersonalExpenseTracker,
        component: PersonalExpenseTracker
    },
    {
        path: "/contributions/all",
        name: RouteNames.ContributionsAll,
        component: ContributionsAll,
        props: route => {
            const pageNumber = route.query && route.query.page ? parseInt(<string>route.query.page, 10) : 1;

            return {
                routeToPages: page => ({ name: RouteNames.ContributionsAll, query: { page } }),
                page: isNaN(pageNumber) ? 1 : pageNumber
            };
        },
        meta: {
          nav_item: EmployeeNavItem.Contributions
        }
    },
    {
        path: "/account-balance",
        name: RouteNames.CashBalance,
        component: CashAccountBalance,
        props: route => {
            const pageNumber = route.query && route.query.page ? parseInt(<string>route.query.page, 10) : 1;
            const filter = parseInt(<string>route.query.transactionFilter) || 0;
            return {
                routeName: RouteNames.CashBalance,
                page: isNaN(pageNumber) ? 1 : pageNumber,
                transactionFilter: filter,
                routeToCashAccountBalance: (page, transactionFilter: TransactionFilter) => ({
                    name: RouteNames.CashBalance,
                    query: {
                        page,
                        transactionFilter
                    }
                })
            };
        },
        meta: {
          nav_item: EmployeeNavItem.Balances
        }
    },
    {
        path: "/portal-redirect",
        name: RouteNames.PortalRedirect,
        component: PartnerPortalRedirect,
        props: route => ({
            portalType: route.query.portalType
        })
    },
    {
        path: "/claim-account",
        name: RouteNames.ClaimAccount,
        component: ClaimAccountVue,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
        props: route => ({
            routeToLogin: routeToName(LoginRouteNames.Login),
            routeToDashboard: routeToName(RouteNames.Dashboard),
            c: route.query.c
        })
    },
    {
        path: "/onboarding/investments/learn-more/:subpage",
        name: RouteNames.DrivewealthLearnMoreOnboarding,
        component: DrivewealthLearnMorePages,
        props: {
            isOnboarding: true,
        },
        meta: {
            hide_footer: true,
            hide_left_nav: true,
            hide_fdic: true
        },
    },
    {
        path: "/onboarding/investments/wizard/:step?",
        name: RouteNames.OnboardingDrivewealthPreenrollment,
        component: PreenrollmentPage,
        props: route => ({
            step: route.params.step,
            wizardNavigationRouteName: RouteNames.OnboardingDrivewealthPreenrollment,
            showTitle: false
        }),
        meta: {
            notifies_forward: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_fdic: true
        },
    },
    {
        path: "/onboarding/:stepKey?",
        name: RouteNames.NamedOnboarding,
        component: Wizard,
        props: route => {
            return {
                goToStep: stepKey => ({
                    name: RouteNames.NamedOnboarding,
                    params: {
                        stepKey
                    }
                }),
                routeToFinish: () => ({
                    name: RouteNames.Home,
                }),
                routeToWizardComplete: () => ({
                    name: RouteNames.Home,
                }),
                stepKey: route.params.stepKey,
            };
        },
        meta: {
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/balance-transfer/:stepKey?",
        name: RouteNames.OnboardingBalanceTransfer,
        component: Transfers,
        props: route => ({ stepKey: route.params.stepKey }),
        beforeEnter: (to, from, next) => {
          const balanceTransferStore = useBalanceTransferStore();
          balanceTransferStore.isOnboarding = true;
          return next();
        },
        meta: {
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
      path: "/transfers/:stepKey?",
      name: RouteNames.Transfers,
      component: Transfers,
      props: route => ({ stepKey: route.params.stepKey }),
      beforeEnter: (to, from, next) => {
        const balanceTransferStore = useBalanceTransferStore();
        balanceTransferStore.isOnboarding = false;
        return next();
      },
      meta: {
        nav_item: EmployeeNavItem.Transfers
      }
    },
    {
      path: "/upfront-contribution/external-account",
      name: RouteNames.OnboardingLinkedAccounts,
      component: OnboardingLinkedAccounts,
      props: route => ({ autoLinkBankAccount: route.params.autoLinkBankAccount }),
      meta: {
        hide_footer: true,
        hide_left_nav: true
      }
    },
    {
      path: "/upfront-contribution/contribution",
      name: RouteNames.OnboardingContribution,
      component: OnboardingContribution,
      meta: {
        hide_footer: true,
        hide_left_nav: true
      }
    },
    {
      path: "/upfront-contribution/schedule-contribution",
      name: RouteNames.OnboardingScheduleContribution,
      component: OnboardingScheduleContribution,
      props: route => ({
        routeToConfirmation: (schedule: TransferSchedule, isUpdate: boolean) => ({
          name: RouteNames.OnboardingConfirmContributionPage,
          params: {
            value: schedule,
            updating: isUpdate
          }
        }),
      }),
      meta: {
        hide_footer: true,
        hide_left_nav: true
      }
    },
    {
      path: "/upfront-contribution/confirm-contribution",
      name: RouteNames.OnboardingConfirmContributionPage,
      component: OnboardingConfirmContributionPage,
      props: route => {
        const page = route.query && route.query.page ? parseInt(<string>route.query.page, 10) : 1;
        return {
          schedule: route.params.value ? route.params.value : null,
          updating: route.params.updating || false,
          page: isNaN(page) ? 1 : page,
          routeToModifySchedule: (schedule: TransferSchedule) => ({
            name: RouteNames.OnboardingScheduleContribution,
            params: {
              value: schedule
            }
          }),
        };
      },
      meta: {
        hide_footer: true,
        hide_left_nav: true
      }
    },
    {
      path: "/upfront-contribution/contribution-scheduled-message",
      name: RouteNames.OnboardingContributionScheduledMessage,
      component: OnboardingContributionScheduledMessage,
      meta: {
        hide_footer: true,
        hide_left_nav: true
      }
    },
    {
      path: "/upfront-contribution/contribution-link-external-bank-accounts",
      name: RouteNames.OnboardingLinkBankAccountLandingPage,
      component: OnboardingLinkBankAccountLandingPage,
      meta: {
        hide_footer: true,
        hide_left_nav: true
      }
    },
    {
        path: "/signup",
        name: RouteNames.Signup,
        component: IndividualSignups,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
        props: route => ({
            routeToLogin: routeToName(LoginRouteNames.OktaLogin),
            partner: route.query.partner ? parseInt(<string>route.query.partner, 10) : null
        })
    },
    {
      path: "/signup/verify",
      name: RouteNames.SignupVerifyEmail,
      component: VerifyEmail,
      meta: {
        allowAnonymous: true,
        hide_footer: true,
        hide_left_nav: true,
        hide_header: true
      }
    },
    {
      path: "/login-info",
      name: RouteNames.LoginInfo,
      component: LoginInfo,
      meta: {
        allowAnonymous: true,
        hide_footer: true,
        hide_left_nav: true,
        hide_header: true
      }
    },
    {
        path: "/umbsso",
        name: RouteNames.UmbSso,
        component: UmbPortalRedirect,
        meta: {
          allowAnonymous: true,
          hide_footer: true,
          hide_left_nav: true,
          hide_header: true
        },
        props: r => ({
            action: r.query.action,
            token: r.query.token
        })
    },
    {
        path: "/sso-validate",
        name: RouteNames.SsoValidateAccount,
        component: SsoValidateAccount,
        meta: { allowAnonymous: true, hide_left_nav: true, hide_header: true, hide_footer: true, logsout: true },
        props: route => ({
            token: route.query.token
        })
    },
    {
        path: "/email-verify",
        name: RouteNames.EmailVerify,
        component: EmailVerify,
        meta: {
            allowAnonymous: true,
            logsout: true,
            notifies_forward: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        },
        props: route => ({
            emailVerificationCode: route.query.c,
            routeToHome: ({
                name: RouteNames.Home,
            })
        })
    },
    {
        path: "/auth/email-verify",
        name: RouteNames.OktaEmailVerify,
        component: OktaEmailVerify,
        meta: {
            allowAnonymous: true,
            logsout: true,
            notifies_forward: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        },
        props: route => ({
            emailVerificationCode: route.query.c,
            signature: route.query.s,
            routeToHome: ({
                name: RouteNames.Home,
            })
        })
    },
    {
        path: "/sso-logout",
        name: RouteNames.SsoLogout,
        component: LoadingSpinnerView,
        meta: {
            allowAnonymous: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/sso-error",
        name: RouteNames.SsoLoginError,
        component: SsoLoginError,
        meta: {
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/wex-redirect",
        name: RouteNames.WexRedirect,
        component: WexRedirect,
        meta: {
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/initiate-impersonation",
        name: RouteNames.InitiateImpersonation,
        component: InitiateImpersonation,
        meta: {
            allowAnonymous: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        },
        props: route => ({
            token: route.query.token
        })
    },
    {
        path: "/saml-error",
        name: RouteNames.SamlError,
        component: SamlError,
        meta: {
            allowAnonymous: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/okta-sso-error",
        name: RouteNames.OktaSsoError,
        component: OktaSsoError,
        meta: {
            allowAnonymous: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        },
        props: route => ({
            referrer: route.query.r,
            reasonCode: route.query.c
        })
    },
    {
        path: "/impersonation-error",
        name: RouteNames.ImpersonationError,
        component: ImpersonationError,
        meta: {
            allowAnonymous: true,
            hide_header: true,
            hide_footer: true,
            hide_left_nav: true
        }
    },
    {
        path: "/auth/credential",
        name: RouteNames.OktaCredential,
        component: HsabClaimAccount,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
        props: route => ({
            routeToClaimAccountVerify: routeToName(RouteNames.OktaCredentialVerify),
            zipCodeProp: route.params.zipCode ? route.params.zipCode : "",
            dateOfBirthProp: route.params.dateOfBirth ? route.params.dateOfBirth : ""
        })
    },
    {
        path: "/auth/credential-verify",
        name: RouteNames.OktaCredentialVerify,
        component: HsabClaimAccountVerify,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_header: true,
            hide_left_nav: true
        },
        props: {
            routeToLogin: routeToName(LoginRouteNames.OktaLogin)
        }
    },
    {
        path: "/hsab-account-selection",
        name: RouteNames.HsabAccountSelection,
        component: HsabAccountSelection,
        meta: {
            hide_footer: true,
            hide_header: true,
            hide_left_nav: true,
            nav_item: EmployeeNavItem.ChangePlans
        }
    },
    {
        path: "/",
        name: RouteNames.HsabNotionalDashboard,
        component: HsabNotionalDashboardComponent,
        meta: {
          nav_item: EmployeeNavItem.NotionalDashboard
        }
    },
    {
        path: "/ebto/claim",
        name: RouteNames.EbtoClaim,
        component: EbtoClaim,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
        props: route => ({
            campaignKey: route.query.c
        })
    },
    {
        path: "/ebto/verification-code",
        name: RouteNames.EbtoVerificationCode,
        component: EbtoVerificationCode,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        }
    },
    {
        path: "/ebto/general-information",
        name: RouteNames.EbtoGeneralInformation,
        component: EbtoGeneralInformation,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        }
    },
    {
        path: "/ebto/offer",
        name: RouteNames.EbtoPricingOffer,
        component: EbtoPricingOffer,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        }
    },
    {
        path: "/ebto/retained",
        name: RouteNames.EbtoRetained,
        component: EbtoRetained,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
    },
    {
        path: "/ebto/esign",
        name: RouteNames.EbtoESignature,
        component: EbtoESignature,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
    },
    {
        path: "/ebto/transfer-process",
        name: RouteNames.EbtoTransferProcess,
        component: EbtoTransferProcess,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
    },
    {
      path: "/message-center",
      name: RouteNames.MessageCenter,
      component: MessageCenter,
      beforeEnter: (to, from, next) => {
        const featureFlagStore = useFeatureFlagStore();

        const navigate = () => {
          if (featureFlagStore.flags.hsa7793MessagingCenter) {
            return next();
          }
          return next(false);
        };

        if (featureFlagStore.featureFlagsAvailable) {
          return navigate();
        }

        const stopWatching = watch(
            () => featureFlagStore.featureFlagsAvailable,
            available => {
              if (available) {
                stopWatching();
                navigate();
              }
            }
        );
      },
      meta: {
        nav_item: EmployeeNavItem.MessageCenter
      },
    },
    {
        path: "/ebto/transfer-complete",
        name: RouteNames.EbtoTransferOutComplete,
        component: EbtoTransferComplete,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_left_nav: true,
            hide_header: true
        },
    },
    {
        path: "/product-scanner",
        name: RouteNames.ProductScanner,
        component: ProductScanner,
        meta: {
          nav_item: EmployeeNavItem.ProductScanner,
          disable_min_height: true
        }
    },
    {
        path: "/auth/sso",
        name: RouteNames.OktaSso,
        component: OktaSso,
        meta: {
            allowAnonymous: true,
            hide_footer: true,
            hide_header: true,
            hide_left_nav: true
        }
    },
    {
      path: "/unsupported-browser",
      name: RouteNames.UnsupportedBrowser,
      component: UnsupportedBrowser,
      meta: {
        allowAnonymous: true,
        hide_footer: true,
        hide_header: true,
        hide_left_nav: true
      }
    },
    {
        path: "*",
        redirect: "/"
    }
];

if (isMobileApp()) {
    routesArray.push({
        path: "/terms-and-conditions",
        name: RouteNames.TermsAndConditions,
        component: TermsAndConditionsMobile
    });
    routesArray.push({
        path: "/privacy",
        name: RouteNames.Privacy,
        component: PrivacyMobile
    });
} else {
    routesArray.push({
        path: "/terms-and-conditions",
        name: RouteNames.TermsAndConditions,
        component: TermsAndConditions
    });
    routesArray.push({
        path: "/privacy",
        name: RouteNames.Privacy,
        component: Privacy
    });
}


const router = new Router({
    routes: routesArray,
    scrollBehavior (from, to) {
    if (_.get(to, "name") !== _.get(from, "name")) {
          return { x: 0, y: 0 }; // scroll to top when the route name changes
    }
    // void return value will be falsey, and that will cause the scroll pos to be retained
    }
});

const getRedirectionToEmailVerify = (routeTo: Route) =>
    (routeTo.name === RouteNames.Home && routeTo.query.c) && ({
        name: RouteNames.EmailVerify,
        query: routeTo.query
    });

// redirect to wizard if the user has not been onboarded
router.beforeEach((to, from, next) => {
    const fdicStore = useFdicStore();
    fdicStore.routeHideFdic = to.meta.hide_fdic;

    if (to.name !== RouteNames.UnsupportedBrowser) {
      const browserStore = useBrowserStore();
      if (browserStore.isUnsupported) {
        next({ name: RouteNames.UnsupportedBrowser });
        return;
      }
    }

    const redirectionToEmailVerify = getRedirectionToEmailVerify(to);

    if (redirectionToEmailVerify) {
        next(redirectionToEmailVerify);
        return;
    }

    const userStore = useUserStore();
    const loginRedirectStore = useLoginRedirectStore();

    const userLoggedIn = userStore.loggedIn;
    const authType = userStore.authType;
    if (!to.matched.some(r => r.meta.allowAnonymous)) {
        if (!userLoggedIn) {
            if (to.name !== LoginRouteNames.Login && !!to.name && to.name !== RouteNames.Home) {
                loginRedirectStore.setRedirectRouteObject({ ...to });
            }
            next({
                name: authType === AuthType.Okta ? LoginRouteNames.OktaLogin : LoginRouteNames.Login,
                query: to.query.returnUrl ? to.query : {
                    ...to.query,
                    returnUrl: to.fullPath
                }
            });
            return;
        }
    }

    const notifierStore = useNotifierStore();
    const wizardStore = useWizardStore();
    const impersonatorStore = useImpersonatorStore();
    const custodianSettingStore = useCustodianSettingsStore();

    if (!from.matched.some(r => r.meta.notifies_forward)) {
        notifierStore.clearAlerts();
    }

    if (to.name === RouteNames.InitiateImpersonation) {
        next();
        return;
    }

    const isComplete = wizardStore.isComplete === true;
    const isImpersonationStarting = impersonatorStore.impersonationIsStarting === true;
    const maxAllowedStepKey: UserOnboardingStepKey = wizardStore.maxAllowedStepKey;
    const goingIntoOnboardingWizard = to.name === RouteNames.NamedOnboarding;

    // check custodian settings for disabled routes
    // if route is disabled, redirect to selected view

    const disabledRoutes = custodianSettingStore.disabledRoutes;

    if (userLoggedIn && disabledRoutes[to.name]) {
        next({ name: disabledRoutes[to.name] });
        return;
    }

    const redirectRouteObject = loginRedirectStore.routeObject;

    if (userLoggedIn && redirectRouteObject) {
        loginRedirectStore.setRedirectRouteObject(null);
        next({ ...redirectRouteObject });
        return;
    }

    const hsabAccountsStore = useHsabAccountsStore();
    // Users who should only see WEX need to be kept off any but the WexRedirect or SsoLoginError pages
    const isWexOnlyAccount = hsabAccountsStore.isWexOnlyAccount;
    if (userLoggedIn && isWexOnlyAccount) {
        if (to.name !== RouteNames.WexRedirect && to.name !== RouteNames.SsoLoginError) {
            next({ name: RouteNames.WexRedirect });
            return;
        }
    }

    // redirect to home view if the employee is logged in
    // prevent them from being able to see login/create-account when already logged in

    if (userLoggedIn && to.name === LoginRouteNames.Login) {
        next({ name: RouteNames.Home });
        return;
    }

    if (userLoggedIn && to.name === LoginRouteNames.OktaLogin) {
        next({ name: RouteNames.Home });
        return;
    }

    if (userLoggedIn && to.name === RouteNames.Signup) {
        next({ name: RouteNames.Home });
        return;
    }

    if (userLoggedIn && to.name === RouteNames.FeeSchedulePrint) {
        next();
        return;
    }

    if (to.matched.some(r => r.meta.logsout)) {
        next();
        return;
    }

    const userFeedbackStore = useUserFeedbackStore();
    if (isMobileApp() && userLoggedIn && userFeedbackTriggerRoutes.includes(from.name)) {
        userFeedbackStore.setIsRouteReady(true);
    }

    let redirectToOnboardingRoute =
        (goingIntoOnboardingWizard && !wizardStore.isNavigationAllowed(to.params.stepKey)) ||
        (!goingIntoOnboardingWizard && userLoggedIn && !isComplete && !isImpersonationStarting);

    if (redirectToOnboardingRoute && [ RouteNames.ClaimAccount,
        LoginRouteNames.ForgotPassword,
        LoginRouteNames.ForgotPasswordVerify,
        LoginRouteNames.UpdatePassword ].some(s => s === to.name)) {
        redirectToOnboardingRoute = false;
    }

    if (to.name === RouteNames.OnboardingDrivewealthPreenrollment &&
        wizardStore.isNavigationAllowed("investments")) {
        redirectToOnboardingRoute = false; // it's already going to a valid onboarding page
    }

    if (to.name === RouteNames.DrivewealthLearnMoreOnboarding &&
        wizardStore.isNavigationAllowed("investments")) {
        redirectToOnboardingRoute = false; // it's already going to a valid onboarding page
    }

    const defaultRedirectLocation: UserOnboardingStepKey = "personal-details";
    // if maxAllowedStep is null, this can be create an infinte recusion. TS thinks params are always strings. I'm sorry
    if (redirectToOnboardingRoute && to.params.stepKey === defaultRedirectLocation && maxAllowedStepKey === null) {
        redirectToOnboardingRoute = false;
    }

    if (redirectToOnboardingRoute) {
        return next(
            { name: RouteNames.NamedOnboarding, params: { stepKey: maxAllowedStepKey || defaultRedirectLocation } });
    }
    if (goingIntoOnboardingWizard && isComplete && userLoggedIn) {
        return next({ name: RouteNames.Home });
    }

    const featureFlagStore = useFeatureFlagStore();
    if (to.name === SharedRoutes.DrivewealthInvestmentAccountV2 && featureFlagStore.flags.bend25653EnableDrivewealthPerformance) {
        next({
            name: SharedRoutes.DrivewealthAccountSummary,
            params: to.params,
            query: to.query
        });
        return;
    }

    next();
});

export default router;
